import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ZoomOut = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '24',
    defaultHeight: '24',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      stroke={primaryColorToUse}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      viewBox='0 0 24 24'
    >
      <circle cx='11' cy='11' r='8' />
      <line x1='21' x2='16.65' y1='21' y2='16.65' />
      <line x1='8' x2='14' y1='11' y2='11' />
    </svg>
  );
};
